import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerImpactMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('impactAnalysis', locale)
}
